module.exports = __webpack_public_path__ + "img/Annotated_Pharaohs_Tomb_Map.2b5e5d28.png";